import type { FeeDefaultBillingUnits } from '@/api/basic-data/fee-management'

/** 从费用主数据或通用搜索完整内容中读取当前业务的默认计费单位，保持长整数 ID 精度。 */
export function getFeeDefaultBillingUnitId(
  feeData: (FeeDefaultBillingUnits & { content?: FeeDefaultBillingUnits }) | null | undefined,
  businessType: 'fcl' | 'lcl' | 'air' | 'preport' | 'lastmile' | 'rail'
): string | undefined {
  const field = `${businessType}DefaultBillingUnitId` as keyof FeeDefaultBillingUnits
  const id = feeData?.[field] ?? feeData?.content?.[field]
  return id === undefined || id === null || id === '' ? undefined : String(id)
}
